import type { ProductTeamMember } from '@data/utils/types';

import { inVersion } from '../productMock';
import { productStore } from './productStore';
import type { ProductVersion } from './productVersions';

export const versionTeamKey = (productId: string, version?: string): string =>
  inVersion(`productVersionTeam:${productId}`, version);

/** Who was put on a version by hand, whether or not they have reported in it yet. */
export const readAddedTo = (productId: string, version?: string): string[] => {
  try {
    const value = JSON.parse(productStore.getItem(versionTeamKey(productId, version)) ?? '[]');
    return Array.isArray(value) ? value.filter((id): id is string => typeof id === 'string') : [];
  } catch {
    return [];
  }
};

export const writeAddedTo = (productId: string, version: string | undefined, ids: string[]): void =>
  productStore.setItem(versionTeamKey(productId, version), JSON.stringify([...new Set(ids)].sort()));

type Dated = Pick<ProductVersion, 'startDate' | 'endDate'>;

export const reportedIn = (member: Pick<ProductTeamMember, 'reportedSpans'>, version: Dated): boolean =>
  (member.reportedSpans ?? []).some(span => span.from <= version.endDate && span.to >= version.startDate);

/** Reported inside its dates, added to it by hand, or not reporting anywhere yet, which is every version. */
export const onVersionTeam = (
  member: Pick<ProductTeamMember, 'membershipId' | 'hasReported' | 'reportedSpans'>,
  version: Dated | null | undefined,
  added: string[],
): boolean => !version || !member.hasReported || added.includes(member.membershipId) || reportedIn(member, version);
